import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import {
  SelectableMode,
  SelectableSettings,
} from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { takeUntil } from 'rxjs';
import { ReferralType } from 'src/app/modules/referrals/interfaces/referrals.model';
import { CaseActionStatus } from 'src/app/modules/student-search/models/student-search-interface';
import { StudentService } from 'src/app/services/student.service';
import { AuthStore } from 'src/app/stores/auth.store';
import {
  dialogAnimationDuration,
  dialogTimer,
} from '../../constants/dialog-specs';
import { formMessages } from '../../constants/form-messages';
import { NOTIFICATION_MESSAGES } from '../../constants/notification-messages';
import { Reason } from '../../interfaces/reason';
import { SubmitCloseRequestExtensiongModel } from '../../models/close-request-extension/submit-close-request-extension-model';
import { User } from '../../models/user';
import { AbstractComponent } from '../abstract-component';

@Component({
    selector: 'app-close-request-for-reevaluation',
    templateUrl: './close-request-for-reevaluation.component.html',
    styleUrls: ['./close-request-for-reevaluation.component.scss'],
    standalone: false
})
export class CloseRequestForReevaluationComponent
  extends AbstractComponent
  implements OnInit {
  // TODO: Right now we are not changing name of this dialog as we need to change in the entire application
  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  @Input() referralSk: string;
  @Input() iepType: ReferralType;
  reason: Reason[] = [
    {
      id: 1,
      description: 'Parent Refusal to Consent',
    },
  ];
  // TODO: We shouldn't be using unknown
  public gridData: unknown[];
  public checkboxOnly: boolean = false;
  public mode: SelectableMode = 'multiple';
  public selectableSettings: SelectableSettings;
  form: FormGroup;
  public format: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };
  user: User;
  isAdditional: boolean = false;

  constructor(
    private studentService: StudentService,
    private authStore: AuthStore,
    private notificationService: NotificationService
  ) {
    super();
    this.form = new FormGroup({
      note: new FormControl({
        value: formMessages.iespReevalNote,
        disabled: true,
      }),
      date: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.user = this.authStore.UserInfo;
    this.isAdditional =
      this.iepType === ReferralType.RequestForAdditionalReevaluation;
  }

  submit(): void {
    const formDatalist: SubmitCloseRequestExtensiongModel =
      new SubmitCloseRequestExtensiongModel({
        ...this.form.getRawValue(),
        CaseActionSK: this.referralSk,
        personSk: this.user.personSk,
        loginId: this.user.loginID,
      });
    this.studentService
      .addCaseActionStatus(formDatalist)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: CaseActionStatus) => {
        if (data) {
          this.notificationService.show({
            content: NOTIFICATION_MESSAGES.submitSuccess,
            cssClass: 'notification-success',
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'success', icon: true },
          });
          this.closeDialog.next();
        }
      });
  }
  onCancel(): void {
    this.closeDialog.next();
  }

  public afterOnDestroy(): void {
    // afterOnDestroy
  }
}
